/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

// Checks if userData roles are valid against at least 1 of the provided appRoles
export const isRoleValid = (userDataRoles = [], appRoles = []) => {
  if (appRoles.length === 0) return true;
  return appRoles.some(userRole => userDataRoles?.includes(userRole));
};

/**
 * Parse JWT
 * @param token jwt
 * @returns {any} parsed jwt
 */
export const parseJwt = (token) => {
  let base64Token = token.split('.')[1] || token;
  base64Token = base64Token.replace(/-/g, '+').replace(/_/g, '/');
  const decodedJwt = decodeURIComponent(
    window
      .atob(base64Token)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(decodedJwt || '{}');
};
